import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import {
    Box, Grid, Card, ListItem,
    CardContent, Button, Avatar, CircularProgress
} from '@material-ui/core';
import {
    useMediaQuery
} from '@material-ui/core';
import { useTranslate, Title, useDataProvider } from 'react-admin';
import colors from '../CustomizedUIs/Colors';
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import { baseApiUrl } from '../dataProvider/sails';
import TextField from '../CustomizedUIs/CustomTextFiled';
import CustomPoper from '../CustomizedUIs/CustomPoper';
import Loading from '../common/loading-page';
import TextButton from '../CustomizedUIs/TextButton';
import GreenSwitch from '../CustomizedUIs/GreenSwitch'
import Axios from 'axios';
import { red, pink } from '@material-ui/core/colors';


const bgColorError = pink['50'];
const textColorError = red['700'];


const useStyles = makeStyles(theme => ({
    searchPaper: {
        padding: '4px 2px',
        display: 'flex',
        alignItems: 'center',
        margin: 'auto 0',
    },
    iconButton: {
        padding: 10,
    },
    TitleSwitch: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: '0.36px',
        color: '#4f5064',
    },
    large: {
        width: theme.spacing(12),
        height: theme.spacing(12),
        backgroundColor: '#f3f7fa',
    },
    avatarIcon: {
        width: 40,
        height: 40,
    },
    underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },
    display: {
        display: 'none',
    },
    input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        },
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    number: {
        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0
        },
        " & input[type=number] ": {
            "-moz-appearance": "textfield",
        }
    },
    TitleCreate: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    textForce: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#4f5064',
        padding: '5px 8px 5px 8px'
    },
    borderForce: {
        width: '25.5px',
        height: '10.5px',
        backgroundColor: '#b4b5bd',
    },
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    TitleLevel: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    borderLevel: {
        borderRadius: '10px',
        border: ' solid 1px #e0f0f2',
        backgroundColor: ' #fafefe',
    },
    textLevel: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#6cb5b8',
        textAlign: 'center'
    },
    textbtnLevel: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    TitleImage: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
        paddingBottom: '20px'
    },
    borderImage: {
        borderRadius: '10px',
        backgroundColor: '#c1e5fa',
        "&:hover": {
            backgroundColor: '#65a9db'
        },
    },
    textBtnImage: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#237fc2',
        padding: '8px',

    },
    textRequired: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.54)',
    },
    textRequiredStar: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        color: '#e1503a',
    },

    btnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: '#ffffff',
        padding: '5px'
    },
    borderUpImange: {
        width: '500px',
        height: ' 145px',
        borderRadius: ' 10px',
        boxShadow: '0 5px 15px 0 rgba(0, 0, 0, 0.05)',
        backgroundColor: ' #ffffff',
    },
    TitleCreate: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
}))
const caretakers = [
    {
        name: 'papa',
        value: "Pappa"
    }, {
        name: 'mama',
        value: "Mamma"
    },
    {
        name: 'faster',
        value: "Faster"
    }
]
export const EditUser = ({ setEditing, ...props }) => {
    const dataProvider = useDataProvider();
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const translate = useTranslate();
    const classes = useStyles();
    const [dataRole, setDataRole] = useState([]);
    const [dataLanguage, setDataLanguage] = useState([]);
    const [openLanguage, setOpenLanguage] = useState(false);
    const [openCaretaker, setOpenCaretaker] = useState(false);
    const [caretaker, setCaretaker] = useState();
    const [role, setRole] = useState();
    const [language, setLanguage] = useState();
    const [avarta, setAvarta] = useState()
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openPoper, setOpenPopper] = React.useState(false);
    const [defaultSystemLanguage, setDefaultSystemLanguage] = useState('');
    const [isSuperUser, setSuperUser] = useState(false)
    const [messsageError, setMessageError] = useState('')
    const [textValue, setTextValue] = React.useState({
        userName: '',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        phoneNumber: '',
        organisation: '',
    });
    const [validate, setValidate] = React.useState({
        lastName: {
            isError: true,
            message: ''
        },
        number: {
            isError: true,
            message: ''
        },
        userName: {
            isError: true,
            message: ''
        },
        firstName: {
            isError: true,
            message: ''
        }, email: {
            isError: true,
            message: ''
        },
        password: {
            isError: true,
            message: ''
        },
        phoneNumber: {
            isError: true,
            message: ''
        },
        organisation: {
            isError: true,
            message: ''
        }
    });

    const textOnChange = prop => (e) => {
        setTextValue({
            ...textValue, [prop]: e.target.value
        })
        validateFc(prop, e.target.value)
    }

    const validateFc = (prop, value) => {
        if (prop === 'userName') {
            if (value.length === 0)
                setValidate({
                    ...validate, [prop]: value.length === 0 ? {
                        isError: true, message: 'required'
                    } : {
                        isError: false, message: ''
                    }
                })
            else {
                setValidate({
                    ...validate, [prop]: value.length > 50 ? {
                        isError: true, message: translate(`pos.user.error.usernamecharacter`)
                    } : {
                        isError: false, message: ''
                    }
                })
            }
        }
        else if (prop === 'email') {
            if (value.length === 0)
                setValidate({
                    ...validate, [prop]: value.length === 0 ? {
                        isError: true, message: 'required'
                    } : {
                        isError: false, message: ''
                    }
                })
            else {
                setValidate({
                    ...validate, [prop]: ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(value)) === true ? {
                        isError: false, message: ''
                    } : {
                        isError: true, message: translate('pos.auth.errorEmail')
                    }
                })

            }
        }
        else
            setValidate({
                ...validate, [prop]: value.length === 0 ? {
                    isError: true, message: 'required'
                } : {
                    isError: false, message: ''
                }
            })

    }

    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
    // const theme = useSelector((state) =>
    //     state.theme === 'dark' ? darkTheme : lightTheme
    // );



    // event select language
    const handleClickOpenLanguage = () => {
        setOpenLanguage(!openLanguage)
    }
    const onChangeLanguage = (value) => {
        setLanguage(value)
        // setLanguageId(language.id)
        // setLanguageCode(language.code)
        setOpenLanguage(false)
    }

    const handleChooseImage = (event) => {
        var files = [...event.target.files]
        var file = files[0]
        const newFile = {
            name: file.name,
            size: file.size,
            file: file,
            error: false,
            loading: false,
            override: false,
            type: file.type
        };
        newFile.fd = URL.createObjectURL(file)
        setAvarta(newFile)
    }
    const handleClosePoper = () => {
        setOpenPopper(false);
    };
    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleSubmitUser = () => {
        setLoading(true)
        const config = {
            // onUploadProgress: function (progressEvent) {
            //     var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            //     setProgress(percentCompleted)
            // },
            headers: { token: localStorage.getItem('token') }
        }
        var body = {
            name: textValue.firstName,
            role: isSuperUser ? 'super_user' : 'user',
            phoneNumber: textValue.phoneNumber,
            language: language.id,
            room: props.roomId

        }
        if (avarta && !avarta.id)
            body.file = true
        let data = new FormData()
        data.append('data', JSON.stringify(body))
        if (avarta && !avarta.id)
            data.append('file', avarta.file)
        Axios
            .put(`${baseApiUrl}/relatives/${props.data.id}`, data, config)
            .then(({ data }) => {
                setEditing({ status: false })
                props.setShowSnackbar({
                    status: true,
                    name: data.data[0].email,
                    message: translate(`pos.relatives.editRelative.success`)

                })
                setTimeout(() => props.setShowSnackbar({ status: false }), 6000)
            })
            .catch(error => {
                if (error.response.data.message === 'notChangeRole')
                    setMessageError('Can not change role')
                else
                    setMessageError(error.response.data.message)
                setLoading(false)
            })

    };

    const getLanguage = (defaultLanguage) => {
        console.log(defaultLanguage)
        dataProvider('GET_LIST', "language", {
            filter: {

            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                setDataLanguage(data);
                console.log(data.find(value => value.code === defaultLanguage.code))
                setLanguage(data.find(value => value.code === defaultLanguage.code))
                setLoading(false);
            })
            .catch(error => {
                console.log('abc')
                setError(error);
                setLoading(false);
            })
    }

    useEffect(() => {
        setCaretaker(caretakers.find(item => item.name === props.data.caretaker))
        console.log(props.data.language)
        getLanguage(props.data.language)
        setTextValue({
            firstName: props.data.name || "",
            phoneNumber: props.data.phoneNumber || "",
        })
        setSuperUser(props.data.role?.includes('super_user'))
        setAvarta(props.data.avarta)
    }, []);

    console.log(dataLanguage, language)
    if (!dataLanguage || !language) return null
    if (loading) return <Loading show={true} />;
    if (error) return null;



    return (
        <Box width='100%' >
            <Title className={classes.TitleCreate} title={translate(`pos.user.title`)} />
            <Box width={!isDesktop ? '95%' : '80%'} m='auto'>
                <Box display='flex' width='100%'>
                    <Box my={1} style={{ width: '500px' }} >
                        <Typography className={classes.TitleCreate}>{translate(`pos.user.create`)}</Typography>
                        {
                            messsageError != "" && (
                                <Box borderRadius='6px' my={1} width={500} bgcolor={bgColorError} py={1}>
                                    <Typography variant='subtitle2' style={{ color: textColorError, margin: '1em' }}>{messsageError}</Typography>
                                </Box>
                            )
                        }
                        <Box mt={3}>
                            <TextField
                                required
                                onBlur={() => {
                                    validateFc('firstName', textValue.firstName)
                                }}
                                id="filled-basic"
                                label={translate(`pos.dashboard.name`)}
                                value={textValue.firstName}
                                error={validate.firstName.message !== "" && validate.firstName.isError}
                                helperText={validate.firstName.message}
                                onChange={textOnChange('firstName')}
                                style={{ width: 500 }}
                                endDom={
                                    <CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.user.TitleFirstName`)}
                                        content={translate(`pos.user.ConstentFirstName`)}
                                        icon={<b>?</b>}
                                    />
                                }
                            />
                        </Box>


                        <Box mt={3}>
                            <TextField
                                className={classes.number}
                                type='number'
                                id="filled-basic"
                                label={translate(`pos.user.phonenumber`)}
                                value={textValue.phoneNumber}
                                onChange={textOnChange('phoneNumber')}
                                style={{ width: 500 }}
                                endDom={
                                    <CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.user.TitlePhoneNumber`)}
                                        content={translate(`pos.user.ConstentPhoneNumber`)}
                                        icon={<b>?</b>}
                                    />
                                }
                            />
                        </ Box>

                        <Box pt={1} pb={0} mt={1} >
                            <SelectBox
                                label={translate(`pos.user.language`)}
                                value={<Box display='flex' alignItems='center' style={{ marginTop: '-5px' }}>
                                    <img alt='' src={`https://www.countryflags.io/${language.code}/flat/32.png`} />
                                    <Box ml={2}><Typography className={classes.TexTSelect} >{language.name}</Typography></Box>
                                </Box>
                                }
                                open={openLanguage}
                                handleClick={handleClickOpenLanguage}
                            >
                                {
                                    dataLanguage.map((Language, index) => (
                                        <Box key={index} className={classes.boxBoder}>
                                            <ListItem style={{ padding: '8px' }} button onClick={() => onChangeLanguage(Language)}>
                                                <img alt='' src={`https://www.countryflags.io/${Language.code}/flat/32.png`} />
                                                <Box ml={2}><Typography className={classes.TexTSelect} >{Language.name}</Typography></Box>
                                            </ListItem>
                                        </Box>
                                    ))
                                }
                            </SelectBox>
                        </Box>
                        <Box style={{ opacity: props.super && props.data.isSuperUser ? 0.5 : 1 }} display='flex' width='157px' borderRadius={4} bgcolor='background.paper' my={3} px={1} alignItems='center'>
                            <Box flexGrow={1}>
                                <Typography className={classes.TitleSwitch}>{'Super user'.toUpperCase()}</Typography>
                            </Box>
                            <GreenSwitch disabled={props.super && props.data.isSuperUser} size='small' checked={isSuperUser} onChange={(event) => {
                                setSuperUser(event.target.checked)
                            }}></GreenSwitch>
                        </Box>
                        <Card style={{ marginTop: "1em" }} className={classes.borderUpImange} >
                            <Grid container style={{ marginTop: "1em" }} item xs={12} sm={12} xl={12} lg={12} >
                                <Grid >
                                    <CardContent>
                                        <Avatar src={avarta ? (avarta.id ? `${baseApiUrl}/media/${avarta.fd}` : avarta.fd) : ""} className={classes.large} classes={{
                                            img: classes.avatarIcon
                                        }} />
                                    </CardContent>

                                </Grid>
                                <Grid>
                                    <CardContent>
                                        <Typography className={classes.TitleImage} gutterBottom>
                                            {translate(`pos.user.changeimage`)}
                                        </Typography>
                                        <Box>
                                            <input accept="image/*" className={classes.display} id="contained-button-file" type='file' onChange={handleChooseImage} />
                                            <label htmlFor="contained-button-file">
                                                <Button variant='contained' color='secondary' component="span">
                                                    {translate(`pos.user.uploadphoto`)}
                                                </Button>
                                            </label>
                                        </Box>
                                    </CardContent>
                                </Grid>
                            </Grid>
                        </Card>
                        <hr style={{ marginTop: "30px", borderTopColor: ' #e6e6eb' }} />
                        <Box display='flex' justifyContent='flex-end'>
                            <Box mr='auto' display='flex'>
                                <Typography className={classes.textRequiredStar} >{translate(`pos.user.star`)}</Typography>
                                <Typography className={classes.textRequired} >{translate(`pos.user.required`)}</Typography>

                            </Box>
                        </Box>
                        <Box display='flex' justifyContent='flex-end'>
                            <Box display='flex' alignItems='flex-end' mr={3} mt={3}  >
                                <TextButton style={{ marginRight: '30px' }} onClick={() => { setEditing({ status: false }) }} />

                                <Button variant="contained" color='primary' size='large' onClick={handleSubmitUser}
                                    disabled={textValue.firstName ? false : true}
                                >
                                    {loading ? (
                                        <CircularProgress
                                            size={20}
                                            thickness={2}
                                            color='inherit'
                                        />
                                    ) : <Typography className={classes.btnCreate}>  {translate(`pos.user.save`)}</Typography>}
                                </Button>
                            </Box>
                        </Box>

                    </Box>
                </Box>

            </Box>
        </Box>
    )

}
export default EditUser

